
import Title from '~/components/common/page-title.vue'

export default {
  name: 'VisionKv',
  components: {
    Title
  }
}
